<!-- 课程大纲列表 -->
<template>
  <div class="courseItem">
    <div class="items" v-for="(item, index) in data" :key="index">
      <div class="title">
        <div>{{ item.modTit }}</div>
        <img v-if="item.url" :src="item.url" height="30" alt="" />
      </div>
      <div class="cont">
        <template v-if="type === '1'">
          <div class="item" v-for="(it, ind) in item.courseCont" :key="ind">
            <div class="tit">{{ it.title }}</div>
            <div>
              <div class="liTit">{{ it.classtitle }}</div>
              <div class="li" :class="{now: it.classList.length === 1 }">
                <div v-for="(v, i) in it.classList" :key="i">{{ v }}</div>
              </div>
            </div>
            <div>
              <div class="liTit">{{ it.studytitle }}</div>
              <div class="li">
                <div v-for="(v, i) in it.study" :key="i">{{ v }}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="type === '2'">
          <div class="item" v-for="(it, ind) in item.courseCont" :key="ind">
            <div>
              <div class="liTit">{{ it.tit }}</div>
              <div class="li">
                <div v-for="(v, i) in it.list" :key="i">{{ v }}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      default: "",
    },
    type: {
      default: "1",
    },
  },
};
</script>
<style lang="scss" scoped>
.courseItem {
  width: 1182px;
  margin: 0 auto 40px auto;

  .items {
    margin-bottom: 30px;
    .title {
      position: relative;
      font-weight: 600;
      margin-bottom: 15px;
      font-size: 22px;
      color: #19232b;
      padding-left: 15px;
      display: flex;
      img {
        position: relative;
        top: -3px;
        left: 15px;
      }
      &::before {
        position: absolute;
        left: 0;
        top: 3px;
        content: "";
        width: 4.29px;
        height: 18.91px;
        display: block;
        background-color: #1086ff;
      }
    }
    .cont {
      background: #ffffff;
      box-shadow: 0 2px 50px 0 #555b9214;
      padding: 30px;

      .item {
        margin-bottom: 15px;
        .tit {
          padding-left: 10px;
          line-height: 38px;
          font-size: 14px;
          margin-bottom: 13px;
          color: #1086ff;
          background: #f8f8f8;
        }
        .liTit {
          font-weight: 600;
          font-size: 14px;
          line-height: 28px;
          color: #19232b;
        }
        .li {
          display: flex;
          flex-wrap: wrap;
          font-size: 14px;
          line-height: 28px;
          color: #616a72;
          div {
            width: calc(33.3% - 6px);
            margin-right: 9px;
            &:nth-child(3){
              margin-right: 0;
            }
          }
        }
        .now div{
          width: 100%;
        }
      }
    }
  }
}
</style>
